import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Box, Button, TextField, Typography } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CustomModal from '../../../../components/modal/CustomModal';
import { setUnitArchive } from '../../../../actions/units.actions';

const ArchiveUnit = ({ unitId, renderOpen, handleSuccess, unitStatus }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const modalRef = useRef(null);
  const [reason, setReason] = useState('');
  const reasonTrimmed = reason.trim();
  const canArchive = Boolean(reasonTrimmed);

  const resetReason = () => setReason('');

  const handleArchive = (e) => {
    e && e.stopPropagation();
    if (!canArchive) {
      return;
    }
    dispatch(setUnitArchive(unitId, reasonTrimmed))
      .then(() => {
        enqueueSnackbar('Unit was archived', {
          variant: 'success',
        });
        resetReason();
        modalRef.current.close();
        history.push('/admin/units/');
        handleSuccess && handleSuccess();
      })
      .catch((error) => {
        console.error('Error archiving unit:', error);
        const errorMessage =
          error?.response?.data?.reason?.[0] ||
          error?.response?.data?.detail ||
          error?.message ||
          'Failed to archive unit. Please try again.';
        enqueueSnackbar(errorMessage, {
          variant: 'error',
        });
      });
  };

  const handleClose = (e) => {
    e && e.stopPropagation();
    resetReason();
    modalRef.current.close();
  };

  return (
    <>
      {unitStatus === 'archived' ? (
        <Box style={{ height: 36 }}></Box>
      ) : (
        <CustomModal
          renderOpen={renderOpen}
          ref={modalRef}
          onClose={resetReason}
          disableBackdropClick
        >
          <Box textAlign="center">
            <Box>
              <ErrorOutlineIcon
                style={{ width: 67, height: 67, color: 'red' }}
              />
            </Box>
            <Typography variant="h6" color="primary">
              <Box fontWeight="bold">
                Warning: Unit archive cannot be undone!
              </Box>
            </Typography>
            <Box mt={2} />
            <Typography variant="body1">
              Are you sure you want to archive the unit along with tenant and
              permit information?
            </Typography>
            <Box mt={1} />
            <Typography variant="body1">
              To{' '}
              <Box component="span" fontWeight="bold">
                transfer
              </Box>{' '}
              a unit{' '}
              <Box component="span" fontWeight="bold">
                Do Not Archive
              </Box>
              , select the pencil icon next to the unit number to edit the unit.
            </Typography>
            <Box mt={1} />
            <Typography variant="body1">
              ¿Está seguro de que desea archivar la unidad junto con la
              información del inquilino y de los permisos?
            </Typography>
            <Box mt={1} />
            <Typography variant="body1">
              Para{' '}
              <Box component="span" fontWeight="bold">
                transferir
              </Box>{' '}
              una unidad{' '}
              <Box component="span" fontWeight="bold">
                No Archive
              </Box>
              , seleccione el icono del lápiz junto al número de unidad para
              editarla.
            </Typography>
            <Box mt={3} textAlign="left">
              <TextField
                id="unit_archive_reason"
                label="Enter reason for move out: / Ingrese el motivo de la mudanza:"
                variant="outlined"
                fullWidth
                required
                multiline
                rows={2}
                value={reason}
                onChange={(e) => setReason(e.target.value.slice(0, 75))}
                inputProps={{ maxLength: 75 }}
                error={!reasonTrimmed && reason.length > 0}
                helperText={`Required — max 75 characters (${reason.length}/75).`}
              />
            </Box>
            <Box mt={7}>
              <Button
                id='unit_archive_cancel_button'
                variant="outlined"
                size="large"
                color="secondary"
                onClick={(e) => handleClose(e)}
              >
                Cancel
              </Button>
              <Box mr={2} component="span" />
              <Button
                id='unit_archive_confirm_button'
                variant="contained"
                size="large"
                disabled={!canArchive}
                style={{
                  color: '#fff',
                  backgroundColor: canArchive ? '#d32f2f' : '#e0e0e0',
                }}
                onClick={(e) => handleArchive(e)}
              >
                Archive Delete Unit
              </Button>
            </Box>
          </Box>
        </CustomModal>
      )}
    </>
  );
};

export default ArchiveUnit;
